import { Constantes } from "../constants/constantsGlobal";
import { iMyDocFileData } from "../models/interfaceMyDocFileData";
import { iResponse } from "../models/interfaceResponse";
import setupInterceptor from "./setupInterceptor";
    
  export const chatbotMyDocsFileData = async (
    docFiles : iMyDocFileData[],
    user: any, 
    setUser: (user: any) => void
  ): Promise<iResponse> => { 
    try {
      const formData = new FormData(); 
      // Agrega cada archivo al FormData
      
      docFiles.forEach((fileData, index) => {
        if(fileData.file){
            formData.append(fileData.filename, fileData.file); 
        } else{ 
            throw new Error(`no se ha encontrado archivo en : ${fileData.name}`);
        } 
      }); 
      const files = docFiles.map((file) => ({
        filename:file.filename,
        name:file.name,
        description:file.description,
        type: file.type
      }));
      formData.append(`data`, JSON.stringify({files:files})); 
      // formData.append(`name_${index}`, fileData.name);
      
        const response = await setupInterceptor(Constantes.URI_ChatBotDatacenterMyDocs, user,setUser, {
          method: 'POST',
          
          body: formData // `formData` automáticamente ajusta el Content-Type a multipart/form-data
        });  
        
/*
      const response = await fetch(Constantes.URI_ChatBotMyDocs, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}` // No se especifica 'Content-Type'
        },
        body: formData // `formData` automáticamente ajusta el Content-Type a multipart/form-data
      });  */
      if (!response.ok) {
        throw new Error(`Error en la solicitud: ${response.statusText}`);
      } 
      const data: iResponse = await response.json();
      return data;
    } catch (error) {
      console.error('Error al enviar datos:', error);
      throw error;
    }
  };

  export const chatbotMyDocsFileDataUpdate = async (
    request : iMyDocFileData,
    user: any, 
    setUser: (user: any) => void
  ): Promise<iResponse> => { 
    try {
      const formData = new FormData(); 
      const response = await setupInterceptor(`${Constantes.URI_ChatBotDatacenterMyDocs}/${request.file_id}`, user,setUser, {
        method: 'PUT', 
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(request)
      });
      if (!response.ok) {
        throw new Error(`Error en la solicitud: ${response.statusText}`);
      } 
      const data: iResponse = await response.json();
      return data;
    } catch (error) {
      console.error('Error al enviar datos:', error);
      throw error;
    }
  };

  export const chatbotMyDocsFileDataDelete = async (
    request : iMyDocFileData,
    user: any, 
    setUser: (user: any) => void
  ): Promise<iResponse> => { 
    try {
        const response = await setupInterceptor(`${Constantes.URI_ChatBotDatacenterMyDocs}/${request.file_id}`, user,setUser, {
          method: 'DELETE', 
        }); 
      if (!response.ok) {
        throw new Error(`Error en la solicitud: ${response.statusText}`);
      } 
      const data: iResponse = await response.json();
      return data;
   
    } catch (error) {
      console.error('Error al enviar datos:', error);
      throw error;
    }
  };

  export const chatbotMyDocsFileDataDowload = async (
    request : iMyDocFileData,
    user: any, 
    setUser: (user: any) => void
  ): Promise<iResponse> => { 
   
    try {
      const formData = new FormData(); 
      const response = await setupInterceptor(`${Constantes.URI_ChatBotDatacenteMyDocsDownload}/${request.file_id}`, user,setUser, {
        method: 'GET', 
        headers: {'Content-Type': 'application/json'},
        
      }); 
      // responseType: 'blob' as 'json' // Para recibir la respuesta como un archivo blob
      if (!response.ok) {
        throw new Error(`Error en la solicitud: ${response.statusText}`);
      }
      
      let data: iResponse;
      const contentType = response.headers.get('content-type'); 
      if (contentType && contentType.includes('application/json')) {
        const jsonData = await response.json();
        data = {
          code: response.status,
          message: response.statusText,
          success: response.ok,
          data: jsonData
        };
      } else {
        const blobData = await response.blob();
        data = {
          code: response.status,
          message: response.statusText,
          success: response.ok,
          data: blobData
        };
      } 
      return data; 
    } catch (error) {
      console.error('Error al enviar datos:', error);
      throw error;
    }
   
  };
